export default "__VITE_ASSET__ChFs7X6I__"